export default __webpack_public_path__ + "locales/zh-CN/ArchiveDialog.json?hash=251a94dd38c6fb1ddcc616e6b976fab3";